{
  "$schema": "passport-stamps-v1",
  "version": "1.0",
  "updatedAt": "2026-03-02",
  "content": {
    "stamps": [
      {
        "code": "first_step",
        "name": "First Step",
        "description": "Complete your onboarding and start your journey",
        "category": "onboarding",
        "rarity": "common",
        "milesValue": 50,
        "icon": "footprints",
        "isActive": true,
        "trigger": {
          "event": "onboarding.completed",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "first_checkup",
        "name": "First CheckUp",
        "description": "Complete your first CheckUp assessment",
        "category": "checkup",
        "rarity": "common",
        "milesValue": 100,
        "icon": "clipboard-check",
        "isActive": true,
        "trigger": {
          "event": "checkup.assessment_completed",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "iqulture_pro",
        "name": "iQulture PRO",
        "description": "Achieve iQulture PRO status (score 80+)",
        "category": "checkup",
        "rarity": "rare",
        "milesValue": 300,
        "icon": "trophy",
        "isActive": true,
        "trigger": {
          "event": "checkup.mesh_calculated",
          "conditions": {
            "band": "PRO"
          }
        }
      },
      {
        "code": "visa_approved",
        "name": "Visa Approved",
        "description": "Your visa or residence permit has been approved",
        "category": "teleportal",
        "rarity": "epic",
        "milesValue": 500,
        "icon": "check-circle",
        "isActive": true,
        "trigger": {
          "event": "teleportal_visa_approved",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "arrived",
        "name": "Arrived at Destination",
        "description": "You have arrived at your destination country",
        "category": "teleportal",
        "rarity": "epic",
        "milesValue": 750,
        "icon": "plane-landing",
        "isActive": true,
        "trigger": {
          "event": "teleportal_arrived",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "housing_secured",
        "name": "Home Sweet Home",
        "description": "You have secured housing at your destination",
        "category": "teleportal",
        "rarity": "rare",
        "milesValue": 300,
        "icon": "home",
        "isActive": true,
        "trigger": {
          "event": "teleportal_housing_secured",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "first_mission",
        "name": "First Mission",
        "description": "Complete your first QultureUp learning mission",
        "category": "qultureup",
        "rarity": "common",
        "milesValue": 80,
        "icon": "target",
        "isActive": true,
        "trigger": {
          "event": "qultureup_mission_completed",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "world_explorer",
        "name": "World Explorer",
        "description": "Complete your first QultureUp world (all tracks)",
        "category": "qultureup",
        "rarity": "rare",
        "milesValue": 200,
        "icon": "globe",
        "isActive": true,
        "trigger": {
          "event": "qultureup_world_completed",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "streak_7",
        "name": "7-Day Streak",
        "description": "Complete QultureUp activities 7 days in a row",
        "category": "qultureup",
        "rarity": "common",
        "milesValue": 70,
        "icon": "flame",
        "isActive": true,
        "trigger": {
          "event": "qultureup_streak_milestone",
          "conditions": {
            "streakDays": 7
          }
        }
      },
      {
        "code": "streak_30",
        "name": "30-Day Streak",
        "description": "Complete QultureUp activities 30 days in a row",
        "category": "qultureup",
        "rarity": "rare",
        "milesValue": 300,
        "icon": "zap",
        "isActive": true,
        "trigger": {
          "event": "qultureup_streak_milestone",
          "conditions": {
            "streakDays": 30
          }
        }
      },
      {
        "code": "first_checkpoint",
        "name": "First Checkpoint",
        "description": "Complete your first Care wellbeing checkpoint",
        "category": "care",
        "rarity": "common",
        "milesValue": 150,
        "icon": "heart-pulse",
        "isActive": true,
        "trigger": {
          "event": "care_checkpoint_completed",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "care_champion",
        "name": "Care Champion",
        "description": "Complete all 4 scheduled Care checkpoints",
        "category": "care",
        "rarity": "rare",
        "milesValue": 400,
        "icon": "medal",
        "isActive": true,
        "trigger": {
          "event": "care_checkpoint_completed",
          "conditions": {
            "count": 4
          }
        }
      },
      {
        "code": "inout_started",
        "name": "InOut started",
        "description": "Start keeping your residence record in InOut",
        "category": "inout",
        "rarity": "common",
        "milesValue": 100,
        "icon": "hourglass",
        "isActive": true,
        "trigger": {
          "event": "inout.setup.completed",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "inout_first_trip",
        "name": "First trip recorded",
        "description": "Record a trip away from your host country",
        "category": "inout",
        "rarity": "common",
        "milesValue": 50,
        "icon": "plane-landing",
        "isActive": true,
        "trigger": {
          "event": "inout.absence.closed",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "inout_trip_planned",
        "name": "Planned ahead",
        "description": "Plan a trip in InOut before you leave",
        "category": "inout",
        "rarity": "uncommon",
        "milesValue": 75,
        "icon": "calendar",
        "isActive": true,
        "trigger": {
          "event": "inout.trip.planned",
          "conditions": {
            "count": 1
          }
        }
      },
      {
        "code": "all_heroes",
        "name": "Full Journey",
        "description": "Activated all 5 heroes in your journey",
        "category": "cross_hero",
        "rarity": "epic",
        "milesValue": 500,
        "icon": "sparkles",
        "isActive": true,
        "trigger": {
          "event": "multi_condition",
          "conditions": {
            "heroes_activated": 5
          }
        }
      },
      {
        "code": "adaptation_master",
        "name": "Adaptation Master",
        "description": "Mastered cultural adaptation across multiple worlds",
        "category": "cross_hero",
        "rarity": "legendary",
        "milesValue": 1000,
        "icon": "crown",
        "isActive": true,
        "trigger": {
          "event": "multi_condition",
          "conditions": {
            "qultureup_worlds_advanced": 3,
            "monthsOnJourney": 12
          }
        }
      },
      {
        "code": "journey_complete",
        "name": "Journey Complete",
        "description": "Successfully completed your entire integration journey",
        "category": "cross_hero",
        "rarity": "legendary",
        "milesValue": 2000,
        "icon": "party-popper",
        "isActive": true,
        "trigger": {
          "event": "ecosystem_journey_completed",
          "conditions": {
            "count": 1
          }
        }
      }
    ]
  }
}
